<template>
  <div class="row mt-3" v-if="consents">
    <div class="col-md-12 text-justify">
      <div class="form-group form-check">
        <input
          type="checkbox"
          class="form-check-input pointerable"
          name="select_all"
          value="1"
          @click="selectAll"
        />
        <label
          class="form-check-label ang-consent"
          style="font-weight: 600; padding-top: 2px"
          >Zaznacz wszystkie</label
        >
      </div>
      <div v-for="(c, c_i) in consents" :key="'consent_' + c_i">
        <div
          v-if="consents.find((c) => !c.required).name === c.name"
          class="form-check-label ang-consent mb-5 mt-5"
          style="font-weight: 600"
        >
          Poniższe zgody są dobrowolne i możesz je w każdej chwili wycofać:
        </div>
        <div class="form-group form-check">
          <input
            type="checkbox"
            class="form-check-input"
            :id="c.name"
            :name="'consents[' + c.name + '][check]'"
            value="1"
            :checked="
              client.consents && client.consents[c.name]
                ? client.consents[c.name].check
                : false
            "
            :required="c.required === 1"
          />

          <div class="d-flex">
            <label class="form-check-label ang-consent" :for="c.name"
              ><span v-if="c.required === 1" class="mr-1">*</span
              ><span v-html="c.title"></span
            ></label>
            <span
              v-if="!c.open"
              class="ml-2 text-xs underline"
              @click="openConsent(c_i, true)"
            >
              <img src="/assets/img/ArrowDown.svg" />
            </span>
            <span
              v-else
              class="ml-2 text-xs underline"
              @click="openConsent(c_i, false)"
            >
              <img src="/assets/img/ArrowUp.svg" />
            </span>
          </div>
          <transition name="fade">
            <div v-if="c.open" class="ang-well mt-1">
              <label class="form-check-label ang-consent" :for="c.name"
                ><span v-html="c.content"></span
              ></label></div
          ></transition>
        </div>
      </div>
    </div>
    <span class="col-md-12 cursor-pointer text-xs d-flex mb-3 mt-5">
      Administrator Twoich danych osobowych
      <!-- <span>...</span> -->
      <span
        @click.prevent.stop="expanded = !expanded"
        class="ml-2 cursor-pointer uppercase font-bold"
        :class="{
          hidden: expanded,
        }"
      >
        <img src="/assets/img/ArrowDown.svg" />
      </span>
      <span
        @click.prevent.stop="expanded = !expanded"
        class="ml-2 cursor-pointer uppercase font-bold"
        :class="{
          hidden: !expanded,
        }"
      >
        <img src="/assets/img/ArrowUp.svg" />
      </span>
    </span>
    <transition name="fade">
      <div class="col-md-12" v-if="expanded && this.clientType == 0">
        <div class="row text-justify">
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Administratorem Twoich danych osobowych jest ANG Odpowiedzialne
              Finanse S.A. z siedzibą w Warszawie przy ul. Dziekońskiego 1,
              00-728 Warszawa, wpisana do rejestru przedsiębiorców Krajowego
              Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st.
              Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru
              Sądowego pod numerem KRS: 0001091847, posiadająca NIP: 5214059967,
              REGON: 527971780 oraz kapitał zakładowy w wysokości 2 400 000,00
              zł w całości opłacony („Administrator”). Z Administratorem można
              kontaktować się pisemnie na ww. adres spółki lub mailowo pod
              adresem: kontakt@angfinanse.pl.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator powołał Inspektora Ochrony Danych (panią Agnieszkę
              Rapcewicz), z którym można się skontaktować pisemnie na ww. adres
              Administratora, z dopiskiem „Inspektor Ochrony Danych” lub mailowo
              pod adresem: IOD@angfinanse.pl.
            </p>
            <p class="ang-consent ang-admin-consent">
              Dane osobowe podane w formularzu, jak również dane podane w toku
              świadczenia na Twoją rzecz usług są przetwarzane w następujących
              celach i na następujących podstawach prawnych:
            </p>
            <ul>
              <li>
                w celu świadczenia na Twoją rzecz usług pośrednictwa
                finansowego, w tym dopasowania i przedstawienia Ci aktualnej
                oferty usług finansowych podmiotów, z którymi współpracuje
                Administrator, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania ustnej umowy świadczenia usług
                pośrednictwa finansowego zawartej pomiędzy Państwem a
                Administratorem (art. 6 ust. 1 lit. b Rozporządzenia Parlamentu
                Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w
                sprawie ochrony osób fizycznych w związku z przetwarzaniem
                danych osobowych i w sprawie swobodnego przepływu takich danych
                oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
                ochronie danych; „RODO”),
              </li>
              <li>
                w celu realizacji usługi rejestracji klienta, świadczonej drogą
                elektroniczną, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania umowy usługi świadczonej drogą
                elektroniczną (art. 6 ust. 1 lit. b RODO),
              </li>
              <li>
                w celu rozpatrywania ewentualnych reklamacji, co stanowi
                realizację ciążących na Administratorze obowiązków prawnych
                (podstawa z art. 6 ust. 1 lit c) RODO w związku z przepisami
                ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji
                przez podmioty rynku finansowego, o Rzeczniku Finansowym i o
                Funduszu Edukacji Finansowej), a w przypadkach, gdy świadczone
                przez nas usługi nie są regulowane przepisami prawa -
                rozpatrywanie reklamacji stanowi nasz prawnie uzasadniony
                interes (podstawa z art. 6 ust. 1 lit. f) RODO),
              </li>
              <li>
                w celu realizacji ciążących na Administratorze obowiązków
                prawnych z zakresu podatków i rachunkowości w szczególności:
                prowadzenia księgowości, rozliczenia podatków, archiwizacji
                danych na potrzeby księgowe (podstawa z art. 6 ust. 1 lit. c)
                RODO w związku z przepisami prawa podatkowego i ustawy o
                rachunkowości),
              </li>
              <li>
                w celu dokonania rozliczenia wynagrodzenia z instytucjami
                finansowymi, z którymi zawarłaś/eś umowę za pośrednictwem
                Administratora, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu obrony przed ewentualnymi roszczeniami, jakie mogą
                wystąpić w związku ze świadczeniem przez Administratora usług na
                Twoją rzecz, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu przeprowadzenia drogą mailową badań satysfakcji klientów,
                na podstawie Twojej zgody (art. 6 ust. 1 lit. a RODO)
              </li>
              <li>
                w celach marketingowych, tj. przesyłania aktualności, ofert
                promocyjnych, informacji o własnych produktach i usługach
                Administratora, na podstawie Twojej zgody (art. 6 ust. 1 lit. a
                RODO),
              </li>
              <li>
                w celu nawiązania z Tobą kontaktu przez Administratora i
                ewentualnego przedstawienia Ci oferty świadczenia usług
                pośrednictwa finansowego w przyszłości, na podstawie zachowanych
                danych o Twoich produktach finansowych, o ile wyraziłaś/eś na to
                zgodę (art. 6 ust. 1 lit. a RODO).
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są pozyskiwane bezpośrednio od Ciebie lub od
              innego podmiotu, któremu wyraziłaś/eś zgodę na udostępnienie
              danych do Administratora (np. od dewelopera).
            </p>
            <p class="ang-consent ang-admin-consent">
              Podanie danych osobowych jest dobrowolne, lecz niezbędne do
              realizacji ww. celów.
            </p>
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są przechowywane przez Administratora przez
              następujący czas
            </p>
            <ul>
              <li>
                przez czas świadczenia usługi pośrednictwa finansowego, a w
                przypadku produktu ubezpieczeniowego – przez cały okres jego
                obowiązywania, a następnie do upływu okresu przedawnienia
                roszczeń,
              </li>
              <li>
                w przypadku danych przetwarzanych na podstawie zgody - do czasu
                jej wycofania przez Ciebie,
              </li>
              <li>
                w przypadku przetwarzania danych w celu realizacji prawnie
                uzasadnionego interesu Administratora – do czasu realizacji tego
                interesu albo skutecznego wniesienia przez Ciebie sprzeciwu
                wobec przetwarzania danych osobowych – w zależności od tego, co
                nastąpi wcześniej.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Odbiorcami Twoich danych osobowych są:
            </p>
            <ul>
              <li>upoważniony personel Administratora,</li>
              <li>
                podmioty świadczące na rzecz Administratora usługi:
                informatyczne, telekomunikacyjne, marketingowe, prawne,
              </li>
              <li>
                instytucje finansowe, których usługami jesteś zainteresowana/y,
              </li>
              <li>
                odbiorcami mogą być także podmioty upoważnione do przetwarzania
                na podstawie przepisów prawa.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Administrator nie zamierza przekazywać Twoich danych osobowych
              poza Europejski Obszar Gospodarczy.
            </p>
            <p class="ang-consent ang-admin-consent">
              Przysługuje Ci prawo do:
            </p>
            <ul>
              <li>
                dostępu do swoich danych osobowych, ich sprostowania, usunięcia
                lub ograniczenia przetwarzania,
              </li>
              <li>prawo do przenoszenia danych,</li>
              <li>
                prawo do cofnięcia zgody na przetwarzanie danych w dowolnym
                momencie (bez wpływu na zgodność z prawem przetwarzania, którego
                dokonano na podstawie zgody przed jej cofnięciem),
              </li>
              <li>
                w przypadku, gdy podstawą przetwarzania danych osobowych jest
                prawnie uzasadniony interes Administratora – prawo wniesienia w
                dowolnym momencie sprzeciwu wobec przetwarzania danych osobowych
                z uwagi na Twoją szczególną sytuację.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Powyższe prawa możesz zrealizować, kontaktując się z Inspektorem
              Ochrony Danych (dane kontaktowe powyżej.)
            </p>
            <p class="ang-consent ang-admin-consent">
              Jeśli masz zastrzeżenia co do tego, jak przetwarzamy Twoje dane
              osobowe, możesz złożyć skargę do: Prezesa Urzędu Ochrony Danych
              Osobowych ul. Stawki 2, 00-193 Warszawa.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator nie podejmuje wobec Ciebie decyzji opartych
              wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu.
            </p>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="col-md-12" v-if="expanded && this.clientType == 1">
        <div class="row text-justify">
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Administratorem Twoich danych osobowych jest ANG Odpowiedzialne
              Finanse S.A. z siedzibą w Warszawie przy ul. Dziekońskiego 1,
              00-728 Warszawa, wpisana do rejestru przedsiębiorców Krajowego
              Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st.
              Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru
              Sądowego pod numerem KRS: 0001091847, posiadająca NIP: 5214059967,
              REGON: 527971780 oraz kapitał zakładowy w wysokości 2 400 000,00
              zł w całości opłacony. Z Administratorem można kontaktować się
              pisemnie na ww. adres spółki lub mailowo pod adresem:
              kontakt@angfinanse.pl.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator powołał Inspektora Ochrony Danych (panią Agnieszkę
              Rapcewicz), z którym można się skontaktować pisemnie na ww. adres
              Administratora, z dopiskiem „Inspektor Ochrony Danych” lub mailowo
              pod adresem: IOD@angfinanse.pl
            </p>
            <p class="ang-consent ang-admin-consent">
              Dane osobowe podane w formularzu, jak również dane podane w toku
              świadczenia na Twoją rzecz usług są przetwarzane w następujących
              celach i na następujących podstawach prawnych:
            </p>

            <ul>
              <li>
                w celu świadczenia na Twoją rzecz usług pośrednictwa
                finansowego, w tym dopasowania i przedstawienia Ci aktualnej
                oferty usług finansowych podmiotów, z którymi współpracuje
                Administrator, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania ustnej umowy świadczenia usług
                pośrednictwa finansowego zawartej pomiędzy Tobą a
                Administratorem (art. 6 ust. 1 lit. b Rozporządzenia Parlamentu
                Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w
                sprawie ochrony osób fizycznych w związku z przetwarzaniem
                danych osobowych i w sprawie swobodnego przepływu takich danych
                oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
                ochronie danych; „RODO”),
              </li>
              <li>
                jeśli reprezentujesz podmiot, z którym Administrator zawiera
                umowę - w celu świadczenia na rzecz podmiotu, który
                reprezentujesz, usług pośrednictwa finansowego, w tym
                dopasowania i przedstawienia aktualnej oferty usług finansowych
                podmiotów, z którymi współpracuje Administrator, a więc
                przetwarzanie danych jest niezbędne do zawarcia i wykonywania
                ustnej umowy świadczenia usług pośrednictwa finansowego zawartej
                pomiędzy podmiotem, który reprezentujesz, Administratorem (art.
                6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu realizacji usługi rejestracji klienta, świadczonej drogą
                elektroniczną, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania umowy usługi świadczonej drogą
                elektroniczną (art. 6 ust. 1 lit. b RODO),
              </li>
              <li>
                w celu rozpatrywania ewentualnych reklamacji, co stanowi
                realizację ciążących na Administratorze obowiązków prawnych
                (podstawa z art. 6 ust. 1 lit c) RODO w związku z przepisami
                ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji
                przez podmioty rynku finansowego, o Rzeczniku Finansowym i o
                Funduszu Edukacji Finansowej), a w przypadkach, gdy świadczone
                przez nas usługi nie są regulowane przepisami prawa -
                rozpatrywanie reklamacji stanowi nasz prawnie uzasadniony
                interes (podstawa z art. 6 ust. 1 lit. f) RODO),
              </li>
              <li>
                w celu dokonania rozliczenia wynagrodzenia z instytucjami
                finansowymi, z którymi została zawarta umowa za pośrednictwem
                Administratora, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu obrony przed ewentualnymi roszczeniami, jakie mogą
                wystąpić w związku ze świadczeniem przez Administratora usług na
                Państwa rzecz, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),w celu
                przeprowadzenia drogą mailową badań satysfakcji klientów, na
                podstawie Twojej zgody (art. 6 ust. 1 lit. a RODO),
              </li>
              <li>
                w celach marketingowych, tj. przesyłania aktualności, ofert
                promocyjnych, informacji o własnych produktach i usługach
                Administratora, na podstawie Twojej zgody (art. 6 ust. 1 lit. a
                RODO),
              </li>
              <li>
                w celu nawiązania z Tobą kontaktu przez Administratora i
                ewentualnego przedstawienia Ci oferty świadczenia usług
                pośrednictwa finansowego w przyszłości, na podstawie zachowanych
                danych o produktach finansowych, o ile wyraziłaś/eś na to zgodę
                (art. 6 ust. 1 lit. a RODO).
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są pozyskiwane bezpośrednio od Ciebie lub od
              innego podmiotu, któremu wyraziłaś/eś zgodę na udostępnienie
              danych do Administratora (np. od dewelopera).
            </p>
            <p class="ang-consent ang-admin-consent">
              Podanie danych osobowych jest dobrowolne, lecz niezbędne do
              realizacji ww. celów.
            </p>
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są przechowywane przez Administratora przez
              następujący czas:
            </p>
            <ul>
              <li>
                przez czas świadczenia usługi pośrednictwa finansowego, a w
                przypadku produktu ubezpieczeniowego – przez cały okres jego
                obowiązywania, a następnie do upływu okresu przedawnienia
                roszczeń,
              </li>
              <li>
                w przypadku danych przetwarzanych na podstawie zgody - do czasu
                jej wycofania przez Ciebie,
              </li>
              <li>
                w przypadku przetwarzania danych w celu realizacji prawnie
                uzasadnionego interesu Administratora – do czasu realizacji tego
                interesu albo skutecznego wniesienia przez Ciebie sprzeciwu
                wobec przetwarzania danych osobowych – w zależności od tego, co
                nastąpi wcześniej.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Odbiorcami Państwa danych osobowych są:
            </p>
            <ul>
              <li>upoważniony personel Administratora,</li>
              <li>
                podmioty świadczące na rzecz Administratora usługi:
                informatyczne, telekomunikacyjne, marketingowe, prawne,
              </li>
              <li>
                instytucje finansowe, których usługami jesteście
                zainteresowana/y,
              </li>
              <li>
                odbiorcami mogą być także podmioty upoważnione do przetwarzania
                na podstawie przepisów prawa.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Administrator nie zamierza przekazywać Twoich danych osobowych
              poza Europejski Obszar Gospodarczy.
            </p>
            <p class="ang-consent ang-admin-consent">
              Przysługuje Państwu prawo do:
            </p>
            <ul>
              <li>
                dostępu do swoich danych osobowych, ich sprostowania, usunięcia
                lub ograniczenia przetwarzania,
              </li>
              <li>prawo do przenoszenia danych,</li>
              <li>
                prawo do cofnięcia zgody na przetwarzanie danych w dowolnym
                momencie (bez wpływu na zgodność z prawem przetwarzania, którego
                dokonano na podstawie zgody przed jej cofnięciem),
              </li>
              <li>
                w przypadku, gdy podstawą przetwarzania danych osobowych jest
                prawnie uzasadniony interes Administratora – prawo wniesienia w
                dowolnym momencie sprzeciwu wobec przetwarzania danych osobowych
                z uwagi na Twoją szczególną sytuację.
              </li>
            </ul>

            <p class="ang-consent ang-admin-consent">
              Powyższe prawa możesz zrealizować, kontaktując się z Inspektorem
              Ochrony Danych (dane kontaktowe powyżej.)
            </p>
            <p class="ang-consent ang-admin-consent">
              Jeśli masz zastrzeżenia co do tego, jak przetwarzamy Twoje dane
              osobowe, możesz złożyć skargę do: Prezesa Urzędu Ochrony Danych
              Osobowych ul. Stawki 2, 00-193 Warszawa.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator nie podejmuje wobec Ciebie decyzji opartych
              wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu.
            </p>
          </div>
        </div>
      </div></transition
    >
    <transition name="fade">
      <div class="col-md-12" v-if="expanded && this.clientType == 2">
        <div class="row text-justify">
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Administratorem Twoich danych osobowych ANG Odpowiedzialne Finanse
              S.A. z siedzibą w Warszawie czytaj dalej przy ul. Dziekońskiego 1,
              00-728 Warszawa, wpisana do rejestru przedsiębiorców Krajowego
              Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st.
              Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru
              Sądowego pod numerem KRS: 0001091847, posiadająca NIP: 5214059967,
              REGON: 527971780 oraz kapitał zakładowy w wysokości 2 400 000,00
              zł w całości opłacony. Z Administratorem można kontaktować się
              pisemnie na ww. adres spółki lub mailowo pod adresem:
              kontakt@angfinanse.pl.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator powołał Inspektora Ochrony Danych (panią Agnieszkę
              Rapcewicz), z którym można się skontaktować pisemnie na ww. adres
              Administratora, z dopiskiem „Inspektor Ochrony Danych” lub mailowo
              pod adresem: IOD@angfinanse.pl
            </p>
            <p class="ang-consent ang-admin-consent">
              Dane osobowe podane w formularzu, jak również dane podane w toku
              świadczenia na Twoją rzecz usług są przetwarzane w następujących
              celach i na następujących podstawach prawnych:
            </p>
            <ul>
              <li>
                w celu świadczenia na Twoją rzecz usług pośrednictwa
                finansowego, w tym dopasowania i przedstawienia Ci aktualnej
                oferty usług finansowych podmiotów, z którymi współpracuje
                Administrator, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania ustnej umowy świadczenia usług
                pośrednictwa finansowego zawartej pomiędzy Tobą a
                Administratorem (art. 6 ust. 1 lit. b Rozporządzenia Parlamentu
                Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w
                sprawie ochrony osób fizycznych w związku z przetwarzaniem
                danych osobowych i w sprawie swobodnego przepływu takich danych
                oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
                ochronie danych; „RODO”),
              </li>
              <li>
                w celu realizacji usługi rejestracji klienta, świadczonej drogą
                elektroniczną, a więc przetwarzanie danych jest niezbędne do
                zawarcia i wykonywania umowy usługi świadczonej drogą
                elektroniczną (art. 6 ust. 1 lit. b RODO),
              </li>
              <li>
                w celu rozpatrywania ewentualnych reklamacji, co stanowi
                realizację ciążących na Administratorze obowiązków prawnych
                (podstawa z art. 6 ust. 1 lit c) RODO w związku z przepisami
                ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji
                przez podmioty rynku finansowego, o Rzeczniku Finansowym i o
                Funduszu Edukacji Finansowej), a w przypadkach, gdy świadczone
                przez nas usługi nie są regulowane przepisami prawa -
                rozpatrywanie reklamacji stanowi nasz prawnie uzasadniony
                interes (podstawa z art. 6 ust. 1 lit. f) RODO),
              </li>
              <li>
                w celu dokonania rozliczenia wynagrodzenia z instytucjami
                finansowymi, z którymi zawarłaś/eś umowę za pośrednictwem
                Administratora, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu obrony przed ewentualnymi roszczeniami, jakie mogą
                wystąpić w związku ze świadczeniem przez Administratora usług na
                Twoją rzecz, co stanowi prawnie uzasadniony interes
                Administratora (art. 6 ust. 1 lit. f RODO),
              </li>
              <li>
                w celu przeprowadzenia drogą mailową badań satysfakcji klientów,
                na podstawie Twojej zgody (art. 6 ust. 1 lit. a RODO),
              </li>
              <li>
                w celach marketingowych, tj. przesyłania aktualności, ofert
                promocyjnych, informacji o własnych produktach i usługach
                Administratora, na podstawie Twojej zgody (art. 6 ust. 1 lit. a
                RODO),
              </li>
              <li>
                w celu nawiązania z Tobą kontaktu przez Administratora i
                ewentualnego przedstawienia Ci oferty świadczenia usług
                pośrednictwa finansowego w przyszłości, na podstawie zachowanych
                danych o Twoich produktach finansowych, o ile wyraziłaś/eś na to
                zgodę (art. 6 ust. 1 lit. a RODO).
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są pozyskiwane bezpośrednio od Ciebie lub od
              innego podmiotu, któremu wyraziłaś/eś zgodę na udostępnienie
              danych do Administratora (np. od dewelopera).
            </p>
            <p class="ang-consent ang-admin-consent">
              Podanie danych osobowych jest dobrowolne, lecz niezbędne do
              realizacji ww. celów.
            </p>
          </div>
          <div class="col-md-6">
            <p class="ang-consent ang-admin-consent">
              Twoje dane osobowe są przechowywane przez Administratora przez
              następujący czas:
            </p>
            <ul>
              <li>
                przez czas świadczenia usługi pośrednictwa finansowego, a w
                przypadku produktu ubezpieczeniowego – przez cały okres jego
                obowiązywania, a następnie do upływu okresu przedawnienia
                roszczeń,
              </li>
              <li>
                w przypadku danych przetwarzanych na podstawie zgody - do czasu
                jej wycofania przez Ciebie,
              </li>
              <li>
                w przypadku przetwarzania danych w celu realizacji prawnie
                uzasadnionego interesu Administratora – do czasu realizacji tego
                interesu albo skutecznego wniesienia przez Ciebie sprzeciwu
                wobec przetwarzania danych osobowych – w zależności od tego, co
                nastąpi wcześniej.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Odbiorcami Twoich danych osobowych są:
            </p>
            <ul>
              <li>upoważniony personel Administratora,</li>
              <li>
                podmioty świadczące na rzecz Administratora usługi:
                informatyczne, telekomunikacyjne, marketingowe, prawne,
              </li>
              <li>
                instytucje finansowe, których usługami jesteście Państwo
                zainteresowani,
              </li>
              <li>
                odbiorcami mogą być także podmioty upoważnione do przetwarzania
                na podstawie przepisów prawa.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Administrator nie zamierza przekazywać Twoich danych osobowych
              poza Europejski Obszar Gospodarczy.
            </p>
            <p class="ang-consent ang-admin-consent">
              Przysługuje Ci prawo do:
            </p>
            <ul>
              <li>
                dostępu do swoich danych osobowych, ich sprostowania, usunięcia
                lub ograniczenia przetwarzania,
              </li>
              <li>prawo do przenoszenia danych,</li>
              <li>
                prawo do cofnięcia zgody na przetwarzanie danych w dowolnym
                momencie (bez wpływu na zgodność z prawem przetwarzania, którego
                dokonano na podstawie zgody przed jej cofnięciem),
              </li>
              <li>
                w przypadku, gdy podstawą przetwarzania danych osobowych jest
                prawnie uzasadniony interes Administratora – prawo wniesienia w
                dowolnym momencie sprzeciwu wobec przetwarzania danych osobowych
                z uwagi na Twoją szczególną sytuację,.
              </li>
            </ul>
            <p class="ang-consent ang-admin-consent">
              Powyższe prawa możesz zrealizować, kontaktując się z Inspektorem
              Ochrony Danych (dane kontaktowe powyżej.)
            </p>
            <p class="ang-consent ang-admin-consent">
              Jeśli masz zastrzeżenia co do tego, jak przetwarzamy Twoje dane
              osobowe, możesz złożyć skargę do: Prezesa Urzędu Ochrony Danych
              Osobowych ul. Stawki 2, 00-193 Warszawa.
            </p>
            <p class="ang-consent ang-admin-consent">
              Administrator nie podejmuje wobec Ciebie decyzji opartych
              wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu.
            </p>
          </div>
        </div>
      </div></transition
    >
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      expanded: false,
    };
  },
  props: ["consents", "clientType", "client"],
  methods: {
    selectAll(el) {
      $("input:checkbox").prop("checked", el.target.checked);
    },
    openConsent(c_i, val) {
      this.consents[c_i].open = val;

      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.form-check {
  margin-bottom: 0.5rem;
}
ul {
  list-style-type: disc;
  padding-left: 20px;
}
ul,
.ang-admin-consent {
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
